module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/search.22019efe.svg";